import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import './index.css';

const OrderComplete: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { cart, customerInfo, shippingAddress, orderInfo, clearCart } = useCart();
  const [sessionId, setSessionId] = useState<string>('');
  const [hogcloudInvoiceId, setHogcloudInvoiceId] = useState<string>('');
  const [orderId, setOrderId] = useState<string>('');
  const [isPickup, setIsPickup] = useState<boolean>(false);
  useEffect(() => {
    // Get session_id from URL parameters
    const params = new URLSearchParams(location.search);
    const sessionIdParam = params.get('session_id');
    const hogcloudInvoiceIdParam = params.get('hogcloud_invoice_id');
    const orderIdParam = params.get('order_id');  
    const isPickupParam = params.get('is_pickup');
    if (sessionIdParam) {
      setSessionId(sessionIdParam);
    }
    if (hogcloudInvoiceIdParam) {
      setHogcloudInvoiceId(hogcloudInvoiceIdParam);
    }
    if (orderIdParam) {
      setOrderId(orderIdParam);
    }
    if (isPickupParam) {
      setIsPickup(isPickupParam.toLowerCase() === 'true');
    }
    // Clear cart after successful order
    if (cart.length > 0) {
      clearCart();
    }
  }, [location, cart, clearCart]);

  const handleContinueShopping = () => {
    navigate('/shop');
  };



  const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (!customerInfo || !orderInfo) {
    return (
      <div className="order-complete-container">
        <div className="order-complete-content">
          <h1>Order Complete!</h1>
          <p>Thank you for your purchase. You will receive a confirmation email shortly.</p>
          <button onClick={handleContinueShopping} className="continue-shopping-btn">
            Continue Shopping
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="order-complete-container">
      <div className="order-complete-content">
        <div className="order-header">
          <h1>🎉 Order Complete!</h1>
          <p className="thank-you-message">
            Thank you for your purchase, {customerInfo.name} for your order!
          </p>
          {isPickup && (
            <p className="thank-you-message">
              You will receive an email when your order is ready for pickup.
            </p>
          )}
          {!isPickup && shippingAddress && (
            <p className="thank-you-message">
              You will receive an email in 2-3 business days when your order is shipped.
            </p>
          )}
        </div>

        <div className="order-details">
          <div className="invoice-section">
            <h2>Order Details</h2>
            <div className="invoice-info">
              <div className="info-row">
                <span className="label">Invoice ID:</span>
                <span className="value">{hogcloudInvoiceId}</span>
              </div>
              <div className="info-row">
                <span className="label">Order ID:</span>
                <span className="value">{orderId}</span>
              </div>
              <div className="info-row">
                <span className="label">Order Date:</span>
                <span className="value">{formatDate(orderInfo?.createdAt ?? new Date())}</span>
              </div>
              <div className="info-row">
                <span className="label">Customer:</span>
                <span className="value">{customerInfo.name}</span>
              </div>
              <div className="info-row">
                <span className="label">Email:</span>
                <span className="value">{customerInfo.email}</span>
              </div>
              {isPickup && (
                <div className="info-row">
                  <span className="label">Pickup</span>
                </div>
              )}
              {shippingAddress && (
                <div className="shipping-address">
                  <span className="label">Shipping Address:</span>
                  <div className="address-details">
                    <div>{shippingAddress.addressLine1}</div>
                    {shippingAddress.addressLine2 && <div>{shippingAddress.addressLine2}</div>}
                    <div>{shippingAddress.city}, {shippingAddress.state} {shippingAddress.zipCode}</div>
                  </div>
                </div>
              )}
            </div>
          </div>


        </div>

        <div className="order-actions">
          <button onClick={handleContinueShopping} className="continue-shopping-btn">
            Continue Shopping
          </button>
        </div>

        <div className="next-steps">
          <h3>What's Next?</h3>
          <ul>
            <li>📧 You'll receive an order confirmation email shortly with your order details</li>
            {!isPickup && (
              <li>📦 Your order will be processed and shipped within 2-3 business days</li>
            )}
            {isPickup && (
              <li>📦 Your order will be ready for pickup at the next available pickup time</li>
            )}
            <li>💬 Need help? Contact us at mailto:support@hogcloud.net</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OrderComplete; 